import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"
import { useMarina } from "src/contexts/MarinaContext"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const Summary = ({ summary, installmentInvoice }) => {
  const { presentmentCurrency } = useMarina()
  const { subtotal, taxAmount, total, discounts, installmentTotal } = summary

  const ROW_VARIANTS = {
    standard: "standard",
    large: "large",
  }

  const renderLabel = (label, variant) => (
    <div
      className={classNames("text-nowrap font-semibold", {
        "!text-lg font-bold": variant === ROW_VARIANTS.large,
      })}
    >
      {label}
    </div>
  )

  const renderValue = (label, value, variant) => {
    return (
      <div
        className={classNames("break-all", {
          "!text-lg font-bold": variant === ROW_VARIANTS.large,
        })}
      >
        {formatCurrencyFromMinorUnits({
          amount: value,
          currency: presentmentCurrency,
        })}
      </div>
    )
  }

  const renderSummaryLine = ({
    label,
    value,
    variant = ROW_VARIANTS.standard,
  }) => (
    <>
      {renderLabel(label, variant)}
      {renderValue(label, value, variant)}
    </>
  )

  const renderDiscount = ({ name, amount }, idx) => (
    <React.Fragment key={idx}>
      {renderSummaryLine({ label: name, value: -amount })}
    </React.Fragment>
  )

  return (
    <div
      className="grid w-fit max-w-96 grid-cols-2 gap-x-8 gap-y-1 p-4"
      data-testid="print-view-summary"
    >
      {!installmentInvoice && (
        <>
          {renderSummaryLine({ label: "Subtotal", value: subtotal })}
          {discounts.map(renderDiscount)}
          {renderSummaryLine({ label: "Tax", value: taxAmount })}
          <div className="col-span-2 pt-4" />
        </>
      )}
      {renderSummaryLine({
        label: "Total",
        value: installmentInvoice ? installmentTotal : total,
        variant: ROW_VARIANTS.large,
      })}
    </div>
  )
}

export const summaryProps = {
  subtotal: PropTypes.number.isRequired,
  taxAmount: PropTypes.number.isRequired,
  discounts: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
    })
  ).isRequired,
  total: PropTypes.number.isRequired,
  installmentTotal: PropTypes.number,
}

Summary.propTypes = {
  summary: PropTypes.shape(summaryProps),
  installmentInvoice: PropTypes.bool.isRequired,
}
export default Summary
